// store/permissionsReducer.js
import * as actionTypes from './actions';

export const initialState = {
  permissions: [],
  loading: false,
  loaded: false,
  error: null
};

const permissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PERMISSIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case actionTypes.FETCH_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissions: action.payload,
        loading: false,
        loaded: true,
        error: null
      };
    case actionTypes.FETCH_PERMISSIONS_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    case actionTypes.CLEAR_PERMISSIONS:
      return initialState;
    default:
      return state;
  }
};

export default permissionsReducer;